
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798F8F","stroke-linecap":"round"}},[_c('path',{staticClass:"i-stroke",attrs:{"stroke-linejoin":"round","d":"M8.592 8.183a4.17 4.17 0 0 0-2.273-.702 4.18 4.18 0 0 0-2.29.647 3.87 3.87 0 0 0-1.5 1.768"}}),_c('path',{staticClass:"i-stroke_2",attrs:{"stroke-linejoin":"round","d":"M10.506 6.768v3.744m0 0v3.744m0-3.744h3.744m-3.744 0H6.762"}}),_c('path',{staticClass:"i-stroke_3",attrs:{"d":"M6.145 7.451a2.471 2.471 0 1 0 0-4.942 2.471 2.471 0 0 0 0 4.942Z"}})])])
          )
        }
      }
    